import { render } from "./NewLeadCard.vue?vue&type=template&id=bd4f4f5a&lang=pug"
import script from "./NewLeadCard.vue?vue&type=script&lang=js"
export * from "./NewLeadCard.vue?vue&type=script&lang=js"

import "./NewLeadCard.vue?vue&type=style&index=0&id=bd4f4f5a&lang=scss"

import exportComponent from "/var/www/valley_watch_firm/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__